import { createContext } from "react";
import { User } from "../crawler/crawler.interface";

export interface UserContextInterface {
    user: User;
    crawlfishUsers: User[];
}
const UserContext = createContext<UserContextInterface>({ user: {} as User, crawlfishUsers: [] as User[] });

export default UserContext;